module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_IncidentalMusic_1961_FPO.d4946eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_IncidentalMusic_1961_FPO.jpg
// module id = JuOh
// module chunks = 0